import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './styles/EmailAndPhoneButton.css';

function EmailAndPhoneButton() {
  return (
    <div className="floating-dock">
      <a href="tel:+4522780476" className="floating-item">
        <span className="floating-icon">
          <FontAwesomeIcon icon={faPhone} />
        </span>
        <span className="floating-label">
          <small>Ring til os</small>
          22 78 04 76
        </span>
      </a>
      <a href="mailto:jbc@jbcentreprenoeren.dk" className="floating-item">
        <span className="floating-icon">
          <FontAwesomeIcon icon={faEnvelope} />
        </span>
        <span className="floating-label">
          <small>Skriv til os</small>
          Send mail
        </span>
      </a>
    </div>
  );
}

export default EmailAndPhoneButton;
